import React, { useState } from "react";
import { connect } from "react-redux";
import { dataActions } from "_actions";
import CalcTable from "./CalcTable";
import TextField from "@material-ui/core/TextField";

const BTSEndTable = ({ btsEndTable, setVal, offBottomSpacing }) => {
  const [state, setState] = useState(btsEndTable);

  const handleChange = (event) => {
    const error = {status: false, msg: null};
    const name = event.target.id;
    const val = event.target.value;
    if(val === ''){
      error.status = true;
      error.msg = 'Empty field';
    }
    const resObj = { ...state, [name]: {
      val,
      error
    } };
    setState(resObj);
    setVal("btsEndTable", resObj);
  };
  return (
    <CalcTable
      id="btsEndTable"
      header="Base Station End"
      cols={["Item", "Value", "Unit"]}
      offBottomSpacing={offBottomSpacing}
      rows={[
        {
          item: "Infrastructure Cost ( Tower, Switch,Power, Cabling Etc)",
          value: (
            <TextField
              id="btsEndInfrastructureCost"
              type="number"
              error={state.btsEndInfrastructureCost.error.status}
              label={state.btsEndInfrastructureCost.error.status ? "Error" : ''}
              helperText={state.btsEndInfrastructureCost.error.status ? state.btsEndInfrastructureCost.error.msg : ''}
              value={state.btsEndInfrastructureCost.val}
              onChange={handleChange}
            />
          ),
          unit: "$",
        },
        {
          item: "AP + Antenna Cost ( To cover 360 deg)",
          value: (
            <TextField
              id="btsEndApAntennaCost"
              type="number"
              error={state.btsEndApAntennaCost.error.status}
              label={state.btsEndApAntennaCost.error.status ? "Error" : ''}
              helperText={state.btsEndApAntennaCost.error.status ? state.btsEndApAntennaCost.error.msg : ''}
              value={state.btsEndApAntennaCost.val}
              onChange={handleChange}
            />
          ),
          unit: "$",
        }
      ]}
    />
  );
};
const mapStateToProps = (state) => {
  return state.dataStore;
};

const mapDispatchToProps = {
  setVal: dataActions.setVal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BTSEndTable);
